/**
 * Validation Rules
 * Centralized validation constraints for forms and inputs.
 */

export const VALIDATION_RULES = {
    // Passwords
    PASSWORD_MIN_LENGTH: 12, // SECURITY: Strict enterprise policy
    PASSWORD_MAX_LENGTH: 128,

    // Contact Info
    PHONE_MIN_LENGTH: 10,
    PHONE_MAX_LENGTH: 15,
    EMAIL_MAX_LENGTH: 254,

    // Codes & OTPs
    OTP_LENGTH: 6,
    RECOVERY_CODE_LENGTH: 6,
    BACKUP_CODE_MIN_LENGTH: 8,
    TOTP_CODE_LENGTH: 6,

    // User Profile
    NAME_MAX_LENGTH: 100,
    USERNAME_MIN_LENGTH: 3,
    USERNAME_MAX_LENGTH: 50,
    COMPANY_MAX_LENGTH: 200,

    // Lost Access
    LOST_ACCESS_REASON_MIN_LENGTH: 10,
    LOST_ACCESS_REASON_MAX_LENGTH: 1000,
} as const;
